module.exports = __webpack_public_path__ + "static/remolqueInverso-3525780e2d465a436445d7e79cf1aaf3.png";